import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Menu, X } from 'react-feather';
import styles from './Header.module.css';

const Header: React.FC = () => {
  const { isAuthenticated, user, userType, logout } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header style={{
      padding: 'var(--space-4) var(--space-5)',
      backgroundColor: 'var(--color-bg-primary)',
      borderBottom: '1px solid var(--color-border-default)',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
          <img
            src="/logo192.png"
            alt="FXTR Logo"
            style={{
              height: '40px',
              width: '40px',
              borderRadius: 'var(--radius-md)'
            }}
          />
          <span style={{
            fontSize: 'var(--text-xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--color-text-primary)'
          }}>
            FXTR Connect
          </span>
        </Link>

        {/* Hamburger Menu Button (Mobile) */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={styles.mobileMenuButton}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Desktop Navigation */}
        <nav className={styles.desktopNav}>
          <ul>
            {isAuthenticated ? (
              <>
                <li>
                  <Link
                    to={userType === 'contractor' ? '/contractor-dashboard' : '/client-dashboard'}
                    style={{ textDecoration: 'none', color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
                  >
                    Dashboard
                  </Link>
                </li>
                <li>
                  <button
                    onClick={handleLogout}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: 'var(--color-text-secondary)',
                      padding: 0,
                      font: 'inherit',
                      fontSize: 'var(--text-sm)',
                      fontWeight: 'var(--font-weight-medium)'
                    }}
                  >
                    Logout
                  </button>
                </li>
                <li style={{ fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-text-primary)', fontSize: 'var(--text-sm)' }}>
                  {(() => {
                    if (!user) return 'Hello, User';
                    // Contractor has `name`, Customer has `firstName`/`lastName`
                    if ('name' in user && user.name) {
                      return `Hello, ${user.name.split(' ')[0]}`;
                    }
                    // fallback to firstName for customers
                    // @ts-ignore - Customer type may not have name
                    if ((user as any).firstName) {
                      // @ts-ignore
                      return `Hello, ${(user as any).firstName}`;
                    }
                    return 'Hello, User';
                  })()}
                </li>
              </>
            ) : (
              <li>
                <Link
                  to="/login"
                  style={{
                    textDecoration: 'none',
                    backgroundColor: 'var(--btn-primary-bg)',
                    color: 'var(--btn-primary-text)',
                    padding: '10px 20px',
                    borderRadius: 'var(--radius-md)',
                    fontWeight: 'var(--font-weight-medium)',
                    fontSize: 'var(--text-sm)'
                  }}
                >
                  Login / Sign Up
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>

      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <nav
          className="mobile-nav"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'var(--color-bg-primary)',
            boxShadow: 'var(--shadow-md)',
            zIndex: 'var(--z-dropdown)'
          }}
        >
          <ul style={{
            listStyle: 'none',
            margin: 0,
            padding: 'var(--space-4) var(--space-5)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-3)'
          }}>
            {isAuthenticated ? (
              <>
                <li>
                  <Link
                    to={userType === 'contractor' ? '/contractor-dashboard' : '/client-dashboard'}
                    style={{ textDecoration: 'none', color: 'var(--color-text-secondary)', display: 'block', padding: 'var(--space-2) 0', fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                </li>
                <li style={{ padding: 'var(--space-2) 0', fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-text-primary)', fontSize: 'var(--text-sm)' }}>
                  {(() => {
                    if (!user) return 'Hello, User';
                    // Contractor has `name`, Customer has `firstName`/`lastName`
                    if ('name' in user && user.name) {
                      return `Hello, ${user.name.split(' ')[0]}`;
                    }
                    // fallback to firstName for customers
                    // @ts-ignore - Customer type may not have name
                    if ((user as any).firstName) {
                      // @ts-ignore
                      return `Hello, ${(user as any).firstName}`;
                    }
                    return 'Hello, User';
                  })()}
                </li>
                <li>
                  <button
                    onClick={() => {
                      handleLogout();
                      setIsMobileMenuOpen(false);
                    }}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: 'var(--color-text-secondary)',
                      padding: 'var(--space-2) 0',
                      font: 'inherit',
                      textAlign: 'left',
                      width: '100%',
                      fontSize: 'var(--text-sm)',
                      fontWeight: 'var(--font-weight-medium)'
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <li>
                <Link
                  to="/login"
                  style={{
                    textDecoration: 'none',
                    backgroundColor: 'var(--btn-primary-bg)',
                    color: 'var(--btn-primary-text)',
                    padding: 'var(--space-3) var(--space-4)',
                    borderRadius: 'var(--radius-md)',
                    fontWeight: 'var(--font-weight-medium)',
                    fontSize: 'var(--text-sm)',
                    display: 'block',
                    textAlign: 'center'
                  }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Login / Sign Up
                </Link>
              </li>
            )}
          </ul>
        </nav>
      )}

    </header>
  );
};

export default Header;